import { render, staticRenderFns } from "./NewTextInput.vue?vue&type=template&id=80a9a76c&scoped=true"
import script from "./NewTextInput.vue?vue&type=script&lang=js"
export * from "./NewTextInput.vue?vue&type=script&lang=js"
import style0 from "./NewTextInput.vue?vue&type=style&index=0&id=80a9a76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a9a76c",
  null
  
)

export default component.exports